export default "__VITE_ASSET__DOFzXEpE__"